import request from "../infra/request";

export const fetchErrorResults = async (aiOcr = false) => {
  try {
    const response = await request.get(`/admin/error-results?aiOcr=${aiOcr}`);
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const deleteErrorResultById = async ({ id, aiOcr }) => {
  try {
    const response = await request.delete(`/admin/error-results/raw/${id}?aiOcr=${aiOcr}`);
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};
